import { DiagnosisOption } from '../imageDiagnosisTypes';

export const equinePainOptions: DiagnosisOption[] = [
  {
    label: '0',
    value: 0,
    color: '#26d882'
  },
  {
    label: '1',
    value: 1,
    color: '#00A3A3'
  },
  {
    label: '2',
    value: 2,
    color: '#FFFF00'
  },
  {
    label: '3',
    value: 3,
    color: '#FFA500'
  },
  {
    label: '4',
    value: 4,
    color: '#FF4500'
  },
  {
    label: '5',
    value: 5,
    color: '#DC143C'
  }
];
